$('.mobile-collection .text-with-icon button').click(function () {
  $('.mobile-collection .collection__facets').slideToggle(300);
  $('.mobile-collection .text-with-icon button').toggleClass('opened');
  if ($('.mobile-collection .text-with-icon button').hasClass('opened')) {
    $('.mobile-collection>.text-with-icon').css('borderBottom', 'none');
  } else {
    setTimeout(() => {
      $('.mobile-collection >.text-with-icon').css('border-bottom', '1px solid rgba(0, 0, 0, 0.1)');
    }, 300);
  }
});

$('.facets__floating-filter>button').click(function() {
  $("#facets-drawer").find('.accordion').removeAttr('open');
})

$(window).on('load', function () {
  var pbadge = $("#product_badge");
  var reveiwsElem = pbadge.parent().find('.overlay-goshop-right b');
  var reviewsCount = pbadge.find('.jdgm-prev-badge').attr('data-number-of-reviews');
  var isProductReviews = pbadge.attr('product_reviews_number_enable');

  if(isProductReviews == 'true') {
    reviewsCount = reviewsCount || '100k+';    
    pbadge.hide();
    reveiwsElem.text(reviewsCount);
  }
  
  window.dispatchEvent(new Event('resize'));
})


// Check for discount message elements periodically
const checkForDiscountMessages = setInterval(() => {


  const giftPrompts = document.querySelectorAll('.rebuy-cart__progress-gift-variant-select-prompt');
  
  if (giftPrompts.length > 0) {
    giftPrompts.forEach(prompt => {
      if(prompt.textContent == 'Re-Add') {
        prompt.textContent = 'Select Gift';
      }
    });
  }

  const discountMessages = document.querySelectorAll('.rebuy-cart__flyout-item-discount-message');
  if (discountMessages.length > 0) {
    document.querySelectorAll('.rebuy-cart__progress-gifts').forEach(el => {
      el.style.display = 'none';
    });
  } else {
    // show .message splide__slide
    document.querySelectorAll('.rebuy-cart__progress-gifts').forEach(el => {
      el.style.display = '';
    });
  }
}, 100); // Check every 1 second


// Set color to black for all <a> tags inside elements with class 'yotpo' every 500ms

setInterval(function() {
  document.querySelectorAll('.yotpo a').forEach(function(el) {
    el.style.setProperty('color', '#000000', 'important');
  });
}, 500);

window.addEventListener('load', function () {
  document.querySelectorAll('.shopify-section--main-collection .yotpo-bottomline-star-rating').forEach(function(el) {
    const link = el.querySelector('.yotpo-bottomline a');
    const temp = link.innerHTML.replace('Reviews', '<span>Reviews</span>');
    link.innerHTML = temp;
    el.style.display = "block";
  })

  document.querySelector('product-rerender .star-clickable').onclick = () => {
    document.querySelector('.shopify-section--apps').scrollIntoView({ behavior: 'smooth' });
  };
});

